// extracted by mini-css-extract-plugin
var _1 = "TopicDetailPreviewPopOver-module__animatedBackground--FxSGK";
var _2 = "TopicDetailPreviewPopOver-module__arrowBg--Jgoa9";
var _3 = "TopicDetailPreviewPopOver-module__arrowStroke--nlsiY";
var _4 = "TopicDetailPreviewPopOver-module__floatingContainer--QZ0Ga";
var _5 = "TopicDetailPreviewPopOver-module__inner--x0urf";
export { _1 as "animatedBackground", _2 as "arrowBg", _3 as "arrowStroke", _4 as "floatingContainer", _5 as "inner" }
